
import Home from './Home/Home';
import Main from './Main/Main';
import Splash from './Splash/Splash';
import Login from './Login/Login';
import Fallback from './Login/Fallback';
import PrivacyPolicy from './PrivacyPolicy/PrivacyPolicy';
import CropImage from './CropImage/CropImage';
import RotateImage from './RotateImage/RotateImage';
import TermsOfUse from './TermsOfUse/TermsOfUse';
import RotatePDF from './pdf/RotatePDF/RotatePDF';
import ReorderPDF from './pdf/ReorderPDF/ReorderPDF';
import ImagesToPDF from './pdf/ImagesToPDF/ImagesToPDF';
import SplitPDF from './pdf/SplitPDF/SplitPDF';
import WatermarkPDF from './pdf/WatermarkPDF/WatermarkPDF';
import EditMetadata from './pdf/EditMetadata/EditMetadata';
import MergePDF from './pdf/MergePDF/MergePDF';
import AboutUs from './About/About';
import ContactUs from './Contact/Contact';

export default {
    Main,
    Home,
    Splash,
    Login,
    Fallback,
    PrivacyPolicy,
    CropImage,
    RotateImage,
    TermsOfUse,
    RotatePDF,
    ReorderPDF,
    ImagesToPDF,
    SplitPDF,
    WatermarkPDF,
    EditMetadata,
    MergePDF,
    AboutUs,
    ContactUs
}